import {Cible} from "./Cible.js";
import {Comparateurs} from "./ComparateurCritère.js";
import {
    classeDeMotValeurs,
    genreValeurs,
    listeMEQValeurs,
    meqComposition,
    meqDérivation,
    meqFormationDuFéminin,
    meqFormationDuPluriel,
    meqThème,
    meqVariationEnGenre,
    meqVariationEnNombre,
    modeValeurs,
    modèleDeConjugaisonValeurs,
    nombreValeurs,
    personneValeurs,
    rectificationOrthographiqueValeurs,
    tempsValeurs, thème,
    typeMotValeurs
} from "./constantes.js";

export const Cibles = Object.freeze({
    GRAPHIE: new Cible("GRAPHIE", "Mot", "", [Comparateurs.COMMENCE_PAR, Comparateurs.CONTIENT, Comparateurs.ÉGALE, Comparateurs.SE_TERMINE_PAR, Comparateurs.NE_COMMENCE_PAS_PAR, Comparateurs.NE_CONTIENT_PAS, Comparateurs.EST_DIFFÉRENT, Comparateurs.NE_SE_TERMINE_PAS_PAR]),
    LEMME: new Cible("LEMME", "Graphie du lemme", "", [Comparateurs.COMMENCE_PAR, Comparateurs.CONTIENT, Comparateurs.ÉGALE, Comparateurs.SE_TERMINE_PAR, Comparateurs.NE_COMMENCE_PAS_PAR, Comparateurs.NE_CONTIENT_PAS, Comparateurs.EST_DIFFÉRENT, Comparateurs.NE_SE_TERMINE_PAS_PAR]),
    PRONONCIATION: new Cible("PRONONCIATION", "Prononciation", "", [Comparateurs.COMMENCE_PAR, Comparateurs.CONTIENT, Comparateurs.ÉGALE, Comparateurs.SE_TERMINE_PAR, Comparateurs.NE_COMMENCE_PAS_PAR, Comparateurs.NE_CONTIENT_PAS, Comparateurs.EST_DIFFÉRENT, Comparateurs.NE_SE_TERMINE_PAS_PAR]),
    CLASSE_DE_MOT: new Cible("CLASSE_DE_MOT", "Classe de mots", "", Cible.comparateursParDéfaut, classeDeMotValeurs),
    GENRE: new Cible("GENRE", "Genre", "", Cible.comparateursParDéfaut, genreValeurs),
    NOMBRE: new Cible("NOMBRE", "Nombre", "", Cible.comparateursParDéfaut, nombreValeurs),
    PERSONNE: new Cible("PERSONNE", "Personne", "", Cible.comparateursParDéfaut, personneValeurs),
    MODE: new Cible("MODE", "Mode", "", Cible.comparateursParDéfaut, modeValeurs),
    TEMPS: new Cible("TEMPS", "Temps", "", Cible.comparateursParDéfaut, tempsValeurs),
    RECTIFICATION_ORTHOGRAPHIQUE: new Cible("RECTIFICATION_ORTHOGRAPHIQUE", "Graphie recommandée par les RO", "", [Comparateurs.ÉGALE], rectificationOrthographiqueValeurs),
    BETA_THÈME: new Cible("BETA_THÈME", "Thème", "", Cible.comparateursParDéfaut, thème),
    TYPE_MOT: new Cible("TYPE_MOT", "Type de mot", "", [Comparateurs.ÉGALE], typeMotValeurs),
    CONJUGAISON_MODÈLE: new Cible("CONJUGAISON_MODÈLE", "Modèle de conjugaison", "", [Comparateurs.ÉGALE], modèleDeConjugaisonValeurs),
    LISTE_MEQ: new Cible("LISTE_MEQ", "Liste du MEQ", "", Cible.comparateursParDéfaut, listeMEQValeurs),
    MEQ_COMPOSITION: new Cible("MEQ_COMPOSITION", "MEQ - Composition", "", Cible.comparateursParDéfaut, meqComposition),
    MEQ_DÉRIVATION: new Cible("MEQ_DÉRIVATION", "MEQ - Dérivation à partir d’une lettre muette", "", Cible.comparateursParDéfaut, meqDérivation),
    MEQ_FORMATION_DU_FÉMININ: new Cible("MEQ_FORMATION_DU_FÉMININ", "MEQ - Formation du féminin", "", Cible.comparateursParDéfaut, meqFormationDuFéminin),
    MEQ_FORMATION_DU_PLURIEL: new Cible("MEQ_FORMATION_DU_PLURIEL", "MEQ - Formation du pluriel", "", Cible.comparateursParDéfaut, meqFormationDuPluriel),
    MEQ_THÈME: new Cible("MEQ_THÈME", "MEQ - Thème", "", Cible.comparateursParDéfaut, meqThème),
    MEQ_VARIATION_EN_GENRE: new Cible("MEQ_VARIATION_EN_GENRE", "MEQ - Variation en genre", "", Cible.comparateursParDéfaut, meqVariationEnGenre),
    MEQ_VARIATION_EN_NOMBRE: new Cible("MEQ_VARIATION_EN_NOMBRE", "MEQ - Variation en nombre", "", Cible.comparateursParDéfaut, meqVariationEnNombre),
});
